import React from "react";
import { PageIntro } from "../components/PageIntro";
import { Reveal } from "../components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQS, waLink } from "../lib/data";
import { ArrowUpRight } from "lucide-react";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <PageIntro
        label="FAQ"
        titleLines={["Everything you", "wanted to ask", "about fresh."]}
      />

      <section className="px-5 md:px-10 py-8 md:py-12">
        <div className="max-w-4xl mx-auto">
          <Reveal>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-black/10"
                >
                  <AccordionTrigger className="py-6 text-left hover:no-underline group [&>svg]:hidden">
                    <span className="flex items-start gap-5 w-full">
                      <span className="font-mono text-sm text-brand-sprout mt-2 shrink-0">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-serif text-2xl md:text-3xl text-brand-ink leading-snug flex-1">
                        {item.q}
                      </span>
                      <span className="font-serif text-3xl text-brand-sprout transition-transform duration-300 group-data-[state=open]:rotate-45 mt-1">
                        +
                      </span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-8 pl-10 pr-10">
                    <p className="text-brand-muted text-base md:text-lg leading-relaxed max-w-2xl">
                      {item.a}
                    </p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>

      <section className="px-5 md:px-10 pb-24 md:pb-32">
        <Reveal>
          <div className="max-w-4xl mx-auto text-center">
            <p className="font-serif text-2xl md:text-3xl text-brand-ink">Still have a question?</p>
            <a
              href={waLink("Hi 40X Leaves, I have a question. ")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="faq-whatsapp-cta"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand-forest text-brand-bg px-8 py-4 text-sm font-semibold transition-transform duration-300 hover:scale-105 hover:bg-brand-sprout"
            >
              Ask us on WhatsApp <ArrowUpRight size={18} />
            </a>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
